import React from 'react';
import { FilterBar } from '@ui';
/**
 * The three multi-select filters (Category, Visibility, File type) plus the
 * name/category search input, all client-side over the already-loaded list.
 */
export function AttachmentsFilterBar({ search, onSearchChange, searchPlaceholder, categoryLabel, categoryOptions, categoryValues, onCategoryChange, visibilityLabel, visibilityOptions, visibilityValues, onVisibilityChange, fileTypeLabel, fileTypeOptions, fileTypeValues, onFileTypeChange }) {
    const filters = [
        {
            type: 'multiSelect',
            field: 'category',
            label: categoryLabel,
            value: categoryValues,
            onChange: onCategoryChange,
            options: categoryOptions
        },
        {
            type: 'multiSelect',
            field: 'visibility',
            label: visibilityLabel,
            value: visibilityValues,
            onChange: onVisibilityChange,
            options: visibilityOptions
        },
        {
            type: 'multiSelect',
            field: 'file_type',
            label: fileTypeLabel,
            value: fileTypeValues,
            onChange: onFileTypeChange,
            options: fileTypeOptions
        }
    ];
    return (React.createElement(FilterBar, { filters: filters, showSearch: true, searchValue: search, onSearchChange: onSearchChange, searchPlaceholder: searchPlaceholder, searchId: "building-attachments-search" }));
}
